export default {
  base: 'Standard',
  LDAP: 'LDAP',
  loginWithCAS: 'Se connecter avec CAS',
  loginWithSAML: 'Se connecter avec SAML',
  loginWithOauth: 'Se connecter avec OAuth2/OpenID',
  documentation: 'Documentation',
  forum: 'Forum',
  website: 'Canopsis.com',
  connectionProtocols: 'Modes de connexion',
  errors: {
    incorrectEmailOrPassword: 'Mot de passe ou Email incorrect',
    underMaintenance: 'Canopsis est en maintenance',
  },
};
